import { Component, computed, input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

import { injectPatientGroups } from '@models/patient-protocol/patient-protocol.api';

import {
  injectNgControl,
  NoopValueAccessorDirective,
} from '@shared/directives/noop-value-accessor.directive';
import { PatientGroupType } from '@shared/services/gql.service';
import { injectFlags } from '@shared/services/launch-darkly.service';
import { Option } from '@shared/types/components.type';

import { VISIT_COST_OPTION } from './constants/visit-cost-option.const';

@Component({
  hostDirectives: [NoopValueAccessorDirective],
  imports: [NgSelectModule, ReactiveFormsModule],
  selector: 'aux-patient-group-dropdown',
  template: `
    <div
      class="min-w-52"
      [class.flex]="horizontalLabel()"
      [class.space-x-2]="horizontalLabel()"
      [class.items-center]="horizontalLabel()"
      [class.min-w-72]="horizontalLabel()"
    >
      @if (label()) {
        <div class="mb-1 text-xs">{{ label() }}</div>
      }
      <ng-select
        [formControl]="ngControl.control"
        placeholder="Select"
        [items]="isVisitCostSelected() ? patientGroupList() : emptyPatientGroupList"
        bindLabel="label"
        bindValue="value"
        [searchable]="true"
        [clearable]="false"
        [dropdownPosition]="'bottom'"
        class="flex-1"
      />
    </div>
  `,
})
export class PatientGroupDropdownComponent {
  flags = injectFlags({ visitCosts: 'visit_costs' });
  ngControl = injectNgControl();
  sitePatientGroups = injectPatientGroups({
    patientGroupTypes: [PatientGroupType.PATIENT_GROUP_STANDARD],
  });

  patientGroupList = computed(() => {
    const res: Option[] = [
      ...(this.sitePatientGroups.data() || []).map((group) => ({
        label: group.name,
        value: group.id,
      })),
    ];

    if (this.flags().visitCosts) {
      res.push(this.visitCostOption);
    }

    return res;
  });

  horizontalLabel = input(false);
  isVisitCostSelected = input(true);
  label = input('Patient Group');

  emptyPatientGroupList: Option[] = [{ label: 'N/A', value: ' ' }];

  private visitCostOption = VISIT_COST_OPTION;
}
